import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const StoreContext = createContext(null);

export function StoreProvider({ children }) {
  const [list, setList] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("tgg_gifting_list")) || [];
    } catch {
      return [];
    }
  });
  const [config, setConfig] = useState({ whatsapp_number: "", contact_email: "", contact_phone: "" });

  useEffect(() => {
    localStorage.setItem("tgg_gifting_list", JSON.stringify(list));
  }, [list]);

  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  const addToList = useCallback((product, qty = 50) => {
    setList((prev) => {
      if (prev.some((p) => p.id === product.id)) return prev;
      return [...prev, { id: product.id, name: product.name, brand: product.brand, image: product.image, qty }];
    });
  }, []);

  const removeFromList = useCallback((id) => setList((prev) => prev.filter((p) => p.id !== id)), []);
  const setQty = useCallback((id, qty) => setList((prev) => prev.map((p) => (p.id === id ? { ...p, qty } : p))), []);
  const clearList = useCallback(() => setList([]), []);
  const inList = useCallback((id) => list.some((p) => p.id === id), [list]);

  return (
    <StoreContext.Provider value={{ list, addToList, removeFromList, setQty, clearList, inList, count: list.length, config }}>
      {children}
    </StoreContext.Provider>
  );
}

export const useStore = () => useContext(StoreContext);
